const MyUser = () => import('@/components/account/MyUser.vue')
const MyAccount = () => import('@/components/account/MyAccount.vue')
const FielUpload = () => import('@/components/account/FielUpload.vue')
const PermissionIndex = () => import('@/components/permissions/IndexPermissions.vue')
const PasswordUser = () => import ('@/components/account/ChangePassword.vue')

export const userInformationRoutes = [
  { path: '/my-account',  component: MyAccount,  meta: { breadcrumb: 'Mi Cuenta', requiresAuth: true } },
  { path: '/my-user',  component: MyUser,  meta: { breadcrumb: 'Mi Usuario', requiresAuth: true } },
  { path: '/configuration', props: route => ({ query: route.query.option }), component: FielUpload, meta: { breadcrumb: 'Configuración de Cuenta', requiresAuth: true } },
  { path: '/', redirect: '/dashboard', meta: { requiresAuth: true } },
  { path: '/permissions', component: PermissionIndex, meta: { breadcrumb: 'Administración de Usuarios - Permisos', requiresAdmin: true, requiresAuth: true }},
  { path:  '/my-password', component: PasswordUser, meta: { breadcrumb: 'Cambiar Mi Contraseña', requiresAuth: true } },
]
